module.exports = __webpack_public_path__ + "img/企业微信.137a0540.svg";